import React, { useState } from 'react';

import { SECONDARY } from 'constants/types';

import { RemoveIcon } from 'styles/components/card.styles';
import { PopupContent, CloseContainer, PopupTitle } from 'styles/pages/settings.styles';

import { Popup } from 'components/Popup';
import { DeliveryInfoForm } from './DeliveryInfoForm';
import { AddressSelectionProps } from 'pages/Totem/TotemDashboard/TotemDashboard.types';
import { useUpdateTotemDeliveryInfoMutation } from 'data/__generated__';

export const DeliveryInfoPopup: React.FC<AddressSelectionProps> = ({ currentTotem, closeAddressPopup }) => {
    const safeCloseAddressPopup = closeAddressPopup ?? (() => {});
    const [deliveryInfo, setDeliveryInfo] = useState(currentTotem);
    const [updateTotemDeliveryInfo, { loading }] = useUpdateTotemDeliveryInfoMutation();

    const isSecondary = currentTotem?.type === SECONDARY;

    const sendFormContent = async (newDeliveryInfo: any) => {
        if (!currentTotem?._id) return;
        await updateTotemDeliveryInfo({
            variables: {
                totemId: currentTotem?._id,
                data: {
                    ...newDeliveryInfo,
                },
            },
        });
    };
    return (
        <Popup isOpen={true} color="white" handleClose={safeCloseAddressPopup} width="455px" overflow="visible">
            <PopupContent $paddings={[2, 2, 2, 2]} $spaceBetween $width="455px" onClick={(e) => e.stopPropagation()}>
                <PopupTitle>Informations de livraison 1</PopupTitle>
                <DeliveryInfoForm
                    currentTotem={currentTotem}
                    deliveryInfo={deliveryInfo}
                    hasLocationRestriction
                    setDeliveryInfo={setDeliveryInfo}
                    sendFormContent={sendFormContent}
                    isAddressNonEditable={isSecondary}
                    onFormSubmitted={closeAddressPopup}
                    loading={loading}
                />
                <CloseContainer>
                    <RemoveIcon size="25px" onClick={closeAddressPopup} />
                </CloseContainer>
            </PopupContent>
        </Popup>
    );
};
